
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* 引言區塊 */}
      <section className="bg-white py-16 border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="space-y-6">
            <p className="text-2xl md:text-3xl text-gray-800 leading-relaxed font-light tracking-wide">
              每一杯咖啡，都有人、山、時間的影子。
            </p>
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-light tracking-wide">
              馬的咖啡故事館，收藏所有讓我們堅持下去的理由。
            </p>
          </div>
          
          {/* 簡潔的分隔線 */}
          <div className="mt-12 flex justify-center">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent"></div>
          </div>
        </div>
      </section>

      {/* 原有的 Hero 區塊 */}
      <section 
        id="home"
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/902b0e2b300c7702d241d16d652cd4f9.jpeg')`
        }}
      >
        <div className="w-full max-w-6xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span style={{ fontFamily: '"Pacifico", serif' }} className="text-amber-300">
              馬的咖啡
            </span>
            <br />
            <span className="text-3xl md:text-4xl font-normal">
              故事館
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-100">
            在卓社林道的原始林中，馬爸爸和馬媽媽用7年時間<br />
            種出最自然、最溫暖的咖啡味道
          </p>
          
          <div className="flex justify-center">
            <Button 
              onClick={() => scrollToSection('story')}
              size="lg"
              className="bg-amber-600 hover:bg-amber-700"
            >
              <i className="ri-book-open-line mr-2"></i>
              聽我們的故事
            </Button>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <button 
            onClick={() => scrollToSection('story')}
            className="w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          >
            <i className="ri-arrow-down-line text-2xl"></i>
          </button>
        </div>
      </section>
    </>
  );
}
